// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveOrZeroInteger, PositiveOrZeroIntegerSchema } from 'api/gen/PositiveOrZeroInteger';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ProductionAreaInCEName, ProductionAreaInCENameSchema } from 'api/gen/ProductionAreaInCEName';

const requiredPart = t.interface({
  id: PositiveOrZeroIntegerSchema,
  name: ProductionAreaInCENameSchema,
});

export const ProductionAreaInCESchema = excess(requiredPart);

export interface ProductionAreaInCE extends t.TypeOf<typeof ProductionAreaInCESchema> {}
